import dayjs from "dayjs";
import { SortByFn } from "react-table";

import { RowData } from "../columns";

const toTimestamp = (value: dayjs.ConfigType | null | undefined) => {
  if (value == null) return null;
  return dayjs(value).valueOf();
};

export const timeSortFn: SortByFn<RowData> = (rowA, rowB, columnId, desc) => {
  const a = toTimestamp(rowA.values[columnId]);
  const b = toTimestamp(rowB.values[columnId]);
  if (a === null && b === null) return 0;
  if (a === null) {
    return 1;
  }
  if (b === null) {
    return -1;
  }
  if (desc) {
    return b - a;
  }
  return a - b;
};
